import {
  ERROR_FETCH_PRIVACY_POLICY,
  START_FETCH_PRIVACY_POLICY,
  SUCCESS_FETCH_PRIVACY_POLICY,
} from 'login-actions/actionTypes';

const initialState = {
  fetching: false,
  success: false,
  error: null,
  content: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUCCESS_FETCH_PRIVACY_POLICY:
      return { ...state, success: true, error: null, fetching: false, content: action.payload };
    case ERROR_FETCH_PRIVACY_POLICY:
      return { ...state, success: false, error: action.payload, fetching: false, content: null };
    case START_FETCH_PRIVACY_POLICY:
      return { ...state, success: false, error: null, fetching: true, content: null };
    default:
      return state;
  }
};
